// import the api endpoints
import { getFeaturedProducts } from '@/api/products.api'

const initialState = () => ({
  dealer: window.PCE_CONFIG.dealer,
  baseApiUrl: window.PCE_CONFIG.baseApiUrl,
  products: [{
  }],
  count: 0
})

const state = initialState()

const getters = {
  dealer: state => {
    return state.dealer
  },
  products: state => {
    return state.products
  },
  count: state => {
    return state.count
  }
}

const actions = {
  fetchProducts ({ commit, state }, num) {
    return new Promise((resolve, reject) => {
      getFeaturedProducts(state.baseApiUrl, state.dealer.id, num).then(
        response => {
          commit('SET_PRODUCTS', response.data)
          commit('SET_COUNT', response.data.length)
          resolve()
        },
        error => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  SET_PRODUCTS (state, data) {
    state.products = data
  },
  SET_COUNT (state, num) {
    state.count = num
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
